import React from 'react';
import { Component } from "puzzle"

class ClaimInstructions extends Component<{}, any> {

  renderBody = () => {
    return (
      <div>
      <span dangerouslySetInnerHTML={{ __html: this.props.getInstructionsData }}>
      </span>
      </div>
    )
  }
}

export default ClaimInstructions;
